module.exports = __webpack_public_path__ + "img/top.ac7dba94.jpg";